module.exports = __webpack_public_path__ + "img/pain-spot-14.def259d2.svg";